export default {
  first_nav_change({
    commit
  }, data) {
    commit('first_nav_change', data)
  },
  is_login({
    commit
  }, data) {
    commit('is_login', data)
  },
  shidao_firstTab({
    commit
  }, data) {
    commit('shidao_firstTab', data)
  },
  zhaiquanTab({
    commit
  }, data) {
    commit('zhaiquanTab', data)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js